import { Button } from '@design-system/button';
import { ExtendableImage } from '@design-system/extendable-image';
import { Typography } from '@design-system/typography';
import { navigate } from 'gatsby';
import React, { FC } from 'react';

import { EmptyStateProps } from './models';

const EmptyState: FC<EmptyStateProps> = ({
  emptyStateTitle,
  emptyStateTitleUI,
  emptyStateDescription,
  emptyStateDescriptionUI,
  emptyStateImage,
  continueShoppingButton,
}) => (
  <div className="shopping-cart__empty-state">
    <ExtendableImage {...emptyStateImage} />
    <Typography
      {...emptyStateTitleUI}
      content={emptyStateTitle}
      className="shopping-cart__empty-state-title"
    />
    <Typography
      {...emptyStateDescriptionUI}
      content={emptyStateDescription}
      className="shopping-cart__empty-state-description"
    />
    <Button
      {...continueShoppingButton}
      className="shopping-cart__continue-button"
      onClick={() => navigate(continueShoppingButton.link)}
    />
  </div>
);

export default EmptyState;
